import { inject } from 'vue';
import i18n       from 'cfg/i18n';

const { t: baseTranslate, tm: baseTranslateMap } = i18n.global;

const resolve = (ns, key)=> key.startsWith('@') && ns ? `${ns}.${key.slice(1)}` : key;

const make = (ns)=> {
  const translate = (key, ...args)=> baseTranslate(resolve(ns, key), ...args);
  translate.map    = (key)=> baseTranslateMap(resolve(ns, key));
  return translate;
};

export default function use$T(domain) {
  return make(domain ?? inject('translationDomain', null));
}

export { use$T };
